let date = new Date();

export default {
    menu:{
        color: '#999999',
        background: '#2e4e5d',
        item:{
            color: '#ffffff',
            background: '#0c343d',
        },
        itemHover:{
            color: '#ffffff',
            background: '#2e4e5d',
        },
        itemActive:{
            color: '#ffffff',
            background: '#0a9189',
        },
    },
    footer:{
        text: '© 2011-' + date.getFullYear() + ' MAG.travel Проект Master-Agent. Все права защищены. +7 (495) 6-020-020, info@mag.travel',
        color: '#ffffff',
        background: '#47634e',
    },
}